import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CreditCardType } from '@platform-frontend/payment-util';
import { Observable } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../checkout-transloco-scope';

@Pipe({
  name: 'cardTypeDescription'
})
export class CardTypeDescriptionPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: CreditCardType | 'INVALID' | null): Observable<string> {
    switch (value) {
      case 'MasterCard':
        return this.translocoService.selectTranslate('paymentInformation.creditCardDescription.masterCard', {}, CHECKOUT_TRANSLOCO_SCOPE);
      case 'Visa':
        return this.translocoService.selectTranslate('paymentInformation.creditCardDescription.visa', {}, CHECKOUT_TRANSLOCO_SCOPE);
      case 'AmericanExpress':
        return this.translocoService.selectTranslate('paymentInformation.creditCardDescription.americanExpress', {}, CHECKOUT_TRANSLOCO_SCOPE);
      case 'INVALID':
        return this.translocoService.selectTranslate('paymentInformation.creditCardDescription.invalid', {}, CHECKOUT_TRANSLOCO_SCOPE);
      default:
        return this.translocoService.selectTranslate('paymentInformation.creditCardDescription.unknown', {}, CHECKOUT_TRANSLOCO_SCOPE);
    }
  }
}
